var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTownOn = function SvgTownOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 27 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#town_on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4D55",
    fillRule: "evenodd",
    d: "M7.668 3c-1.29 0-2.342.243-3.108.95-.757.7-1.104 1.735-1.279 2.996l-.003.027-.25 2.553c-.115.946.136 1.85.64 2.574a.7.7 0 0 0-.022.174v4.18c0 2.16.429 3.85 1.563 4.984S8.033 23 10.192 23h5.019c2.158 0 3.849-.429 4.983-1.562s1.562-2.825 1.562-4.983v-4.181a.7.7 0 0 0-.03-.203 3.7 3.7 0 0 0 .645-2.03v-.027c0-.127 0-.31-.023-.492l-.26-2.552-.003-.024c-.175-1.261-.522-2.296-1.279-2.995C20.042 3.243 18.989 3 17.699 3H7.669M5.022 16.455V13.28c.379.194.798.327 1.246.382.164.022.353.035.544.024a3.84 3.84 0 0 0 2.977-1.525 3.45 3.45 0 0 0 2.446 1.501c.177.025.338.024.459.024h.007a3.45 3.45 0 0 0 2.904-1.498 3.84 3.84 0 0 0 2.973 1.498c.65.014 1.265-.14 1.803-.42v3.188c0 2.022-.41 3.26-1.16 4.01-.684.684-1.776 1.085-3.499 1.15V20.03a2.74 2.74 0 0 0-3.016-3.066A2.74 2.74 0 0 0 9.69 20.03v1.587c-1.73-.064-2.824-.465-3.51-1.15-.75-.75-1.16-1.989-1.16-4.011",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "town_on_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h26v26H.5z"
  })))));
};
export default SvgTownOn;